/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CRSFSourcelistsData
 */
export interface CRSFSourcelistsData {
    /**
     * 
     * @type {boolean}
     * @memberof CRSFSourcelistsData
     */
    ecrime: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CRSFSourcelistsData
     */
    log4j: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CRSFSourcelistsData
     */
    other: boolean;
}

/**
 * Check if a given object implements the CRSFSourcelistsData interface.
 */
export function instanceOfCRSFSourcelistsData(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "ecrime" in value;
    isInstance = isInstance && "log4j" in value;
    isInstance = isInstance && "other" in value;

    return isInstance;
}

export function CRSFSourcelistsDataFromJSON(json: any): CRSFSourcelistsData {
    return CRSFSourcelistsDataFromJSONTyped(json, false);
}

export function CRSFSourcelistsDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): CRSFSourcelistsData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'ecrime': json['ecrime'],
        'log4j': json['log4j'],
        'other': json['other'],
    };
}

export function CRSFSourcelistsDataToJSON(value?: CRSFSourcelistsData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'ecrime': value.ecrime,
        'log4j': value.log4j,
        'other': value.other,
    };
}

